function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var PeerService = require('saito-js/lib/peer_service')["default"];
var FaucetHome = require('./faucet.template');
var FaucetDB = require('./lib/db');
var FaucetWallet = require('./lib/wallet');
var FaucetOAuth = require('./lib/oauth');
var Auth = require('./lib/ui/auth');
var Waiting = require('./lib/ui/waiting');
var Success = require('./lib/ui/success');
var Main = require('./lib/ui/main');
var _require = require('./lib/mode'),
  readFaucetMode = _require.readFaucetMode,
  saveFaucetMode = _require.saveFaucetMode;
var FREE_USE_COOLDOWN_MS = 24 * 60 * 60 * 1000;
var Faucet = /*#__PURE__*/function (_ModTemplate) {
  function Faucet(app) {
    var _this;
    _classCallCheck(this, Faucet);
    _this = _callSuper(this, Faucet, [app]);
    _this.name = 'Faucet';
    _this.slug = 'faucet';
    _this.description = 'Testnet Faucet for Testing and Application Development';
    _this.categories = 'Utility Ecommerce NFTs';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.icon_fa = 'fa-solid fa-faucet';
    _this.styles = ['/faucet/style.css'];
    _this.amount = BigInt(100) * BigInt(100000000);
    _this.db = new FaucetDB(app, _this);
    _this.wallet = new FaucetWallet(app, _this);
    _this.oauth = new FaucetOAuth(app, _this);
    _this.main = new Main(app, _this);
    _this.auth_overlay = new Auth(app, _this);
    _this.waiting_overlay = new Waiting(app, _this);
    _this.success_overlay = new Success(app, _this);

    // Server Faucet capability as last reported to this browser. Unavailable
    // until a successful `faucet available` reply from a discovered Faucet peer.
    _this.server_faucet_available = false;
    _this.server_faucet_amount = 0;
    _this.server_faucet_free_use = false;
    _this.faucet_peer_public_key = '';

    // Re-check when the user asks to see acquisition options. This is
    // event-driven: no polling or timer-based retries.
    app.connection.on('saito-purchase-overlay-open', function () {
      _this.checkFaucetAvailability();
    });

    // Server Faucet mode flags are persisted in app.options.faucet.mode.
    _this.mode = {
      free: false,
      github: false,
      twitter: false
    };
    _this.free_use = false;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: '🟥 Saito Faucet',
      url: '/faucet/',
      description: 'Get Started wtih SAITO',
      image: 'https://saito.tech/wp-content/uploads/2023/11/faucet-300x300.png'
    });
    return _this;
  }
  _inherits(Faucet, _ModTemplate);
  return _createClass(Faucet, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this$app$options, _this$app$options2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Faucet, "initialize", this, 3)([app]);
            case 1:
              if (this.app.BROWSER) {
                _context.n = 3;
                break;
              }
              this.oauth.secret_github = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.faucet) === null || _this$app$options === void 0 ? void 0 : _this$app$options.github_secret) || null;
              this.oauth.secret_twitter = ((_this$app$options2 = this.app.options) === null || _this$app$options2 === void 0 || (_this$app$options2 = _this$app$options2.faucet) === null || _this$app$options2 === void 0 ? void 0 : _this$app$options2.twitter_secret) || null;
              this.mode = readFaucetMode(this.app.options);
              this.free_use = this.mode.free;
              _context.n = 2;
              return this.db.initialize();
            case 2:
              _context.n = 3;
              return this.wallet.initialize();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER) {
        services.push(new PeerService(null, 'faucet'));
      }
      return services;
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, peer) {
        var service,
          dest,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              service = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              if (this.app.BROWSER) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (!(service.service !== 'faucet')) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              dest = String((peer === null || peer === void 0 ? void 0 : peer.publicKey) || '').trim();
              if (dest) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              this.faucet_peer_public_key = dest;
              _context2.n = 4;
              return this.checkFaucetAvailability(dest);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onPeerServiceUp(_x2, _x3) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "onConnectionStable",
    value: function () {
      var _onConnectionStable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, peer) {
        var dest;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              dest = String((peer === null || peer === void 0 ? void 0 : peer.publicKey) || '').trim();
              if (!(!dest || dest !== this.faucet_peer_public_key)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return this.checkFaucetAvailability(dest);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onConnectionStable(_x4, _x5) {
        return _onConnectionStable.apply(this, arguments);
      }
      return onConnectionStable;
    }()
  }, {
    key: "checkFaucetAvailability",
    value: function () {
      var _checkFaucetAvailability = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this2 = this;
        var publicKey,
          dest,
          _args4 = arguments,
          _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              publicKey = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
              if (this.app.BROWSER) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              dest = String(publicKey || this.faucet_peer_public_key || '').trim();
              if (dest) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              _context4.p = 2;
              _context4.n = 3;
              return this.app.network.sendRequestAsTransaction('faucet available', {}, function (res_tx) {
                var res = {};
                try {
                  if (res_tx && typeof res_tx.returnMessage === 'function') {
                    res = res_tx.returnMessage() || {};
                  } else if (res_tx && _typeof(res_tx) === 'object') {
                    res = res_tx;
                  }
                } catch (err) {
                  return;
                }
                if (res.err || typeof res.available !== 'boolean') {
                  return;
                }
                _this2.server_faucet_available = res.available === true;
                _this2.server_faucet_amount = _this2.server_faucet_available ? Number(res.amount) || 0 : 0;
                _this2.server_faucet_free_use = res.free_use === true;
                try {
                  var buysaito = _this2.app.modules.returnModule('BuySaito');
                  var purchase = buysaito === null || buysaito === void 0 ? void 0 : buysaito.purchase_overlay;
                  if (purchase !== null && purchase !== void 0 && purchase.active && typeof purchase.renderAcquisitionOptions === 'function' && document.querySelector('#purchase-container')) {
                    purchase.renderAcquisitionOptions();
                  }
                } catch (err) {
                  // BuySaito may be absent; availability still lives on this module.
                }
              }, dest);
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function checkFaucetAvailability() {
        return _checkFaucetAvailability.apply(this, arguments);
      }
      return checkFaucetAvailability;
    }()
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this3 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'admin-config') {
        return {
          id: this.returnSlug(),
          name: this.name,
          getConfig: function () {
            var _getConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    return _context5.a(2, _this3.adminConfigSnapshot());
                }
              }, _callee5);
            }));
            function getConfig() {
              return _getConfig.apply(this, arguments);
            }
            return getConfig;
          }(),
          updateConfig: function () {
            var _updateConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
              var config,
                _args6 = arguments;
              return _regenerator().w(function (_context6) {
                while (1) switch (_context6.n) {
                  case 0:
                    config = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                    return _context6.a(2, _this3.updateAdminConfig(config));
                }
              }, _callee6);
            }));
            function updateConfig() {
              return _updateConfig.apply(this, arguments);
            }
            return updateConfig;
          }()
        };
      }
      if (type === 'buysaito-options') {
        if (!this.app.BROWSER || this.server_faucet_available !== true) {
          return null;
        }
        var free_use = this.server_faucet_free_use === true;
        return {
          id: 'faucet',
          title: 'Click Here for SAITO from the token faucet...',
          description: free_use ? 'You may request a small amount once every 24 hours to try the network. No registration is required.' : 'You may request a small amount to try the network. Registration with a Github or Twitter account is needed to ensure our limited supply goes to real users and developers.',
          icon: this.icon_fa,
          rank: 1,
          option_class: 'buysaito-option-faucet',
          inline_stage: 'faucet-auth',
          available: true,
          amount: this.server_faucet_amount,
          auth_message: free_use ? 'The SAITO Faucet exists to help users try the advanced features of the network. No registration is required, and each public key may claim once every 24 hours.' : '',
          providers: free_use ? [{
            id: 'free_use',
            name: 'No Registration Required',
            label: 'Get Testnet Tokens'
          }] : [{
            id: 'twitter',
            name: 'X',
            icon: 'fa-brands fa-x-twitter'
          }, {
            id: 'github',
            name: 'GitHub',
            icon: 'fa-brands fa-github'
          }],
          beginProviderAuth: function beginProviderAuth(providerId) {
            var id = String(providerId || '').trim().toLowerCase();
            if (!id) {
              return;
            }
            if (id === 'free_use') {
              _this3.requestFreeUse();
              return;
            }
            _this3.auth_overlay.authenticate({
              id: id
            });
          }
        };
      }
      return _superPropGet(Faucet, "respondTo", this, 3)([type, obj]);
    }

    /**
     * Browser: ask the Faucet peer to register this wallet without OAuth.
     * Server replies on the existing faucet-oauth-result path.
     */
  }, {
    key: "requestFreeUse",
    value: function () {
      var _requestFreeUse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var dest, _t2;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (!(!this.app.BROWSER || this.server_faucet_free_use !== true)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              dest = String(this.faucet_peer_public_key || '').trim();
              if (dest) {
                _context7.n = 2;
                break;
              }
              console.error('[Faucet] requestFreeUse: no faucet peer');
              return _context7.a(2);
            case 2:
              _context7.p = 2;
              _context7.n = 3;
              return this.app.network.sendRequestAsTransaction('faucet free use', {}, null, dest);
            case 3:
              _context7.n = 5;
              break;
            case 4:
              _context7.p = 4;
              _t2 = _context7.v;
              console.error('[Faucet] requestFreeUse failed', _t2);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 4]]);
      }));
      function requestFreeUse() {
        return _requestFreeUse.apply(this, arguments);
      }
      return requestFreeUse;
    }()
    /**
     * Bind an authenticated identity to a Faucet record.
     * Existing record → already registered. New record → browser auto-claims.
     */
  }, {
    key: "acceptAuthenticatedIdentity",
    value: function () {
      var _acceptAuthenticatedIdentity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _peer4, _peer5;
        var identity,
          record,
          _peer2,
          _peer3,
          _peer,
          peers,
          peer,
          _peers,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              identity = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
              console.log('[Faucet] acceptAuthenticatedIdentity provider=' + (identity.provider || '') + ' provider_user_id=' + (identity.provider_user_id || '') + ' publickey=' + (identity.publickey || ''));
              if (!(identity.provider === 'free_use' && this.free_use === true)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, this.acceptFreeUseIdentity(identity));
            case 1:
              _context8.n = 2;
              return this.db.getRecord(identity);
            case 2:
              record = _context8.v;
              console.log('[Faucet] acceptAuthenticatedIdentity record=' + (record ? 'found status=' + (record.issuance_status || '') : 'none'));
              if (!record) {
                _context8.n = 8;
                break;
              }
              _context8.n = 3;
              return this.db.insertActivity({
                requester_publickey: identity.publickey,
                provider: identity.provider,
                provider_user_id: identity.provider_user_id,
                provider_username: identity.provider_username,
                requested_amount: this.amount.toString(),
                request_status: 'rejected',
                request_reason: 'already_issued',
                payment_status: 'none'
              });
            case 3:
              _context8.n = 4;
              return this.app.network.getPeer(identity.publickey);
            case 4:
              _peer = _context8.v;
              if ((_peer2 = _peer) !== null && _peer2 !== void 0 && _peer2.publicKey) {
                _context8.n = 6;
                break;
              }
              _context8.n = 5;
              return this.app.network.getPeers();
            case 5:
              peers = _context8.v;
              _peer = peers.find(function (p) {
                return (p === null || p === void 0 ? void 0 : p.publicKey) === identity.publickey && (p === null || p === void 0 ? void 0 : p.status) !== 'disconnected';
              });
            case 6:
              console.log('[Faucet] acceptAuthenticatedIdentity already registered — not issuing');
              if (!((_peer3 = _peer) !== null && _peer3 !== void 0 && _peer3.publicKey)) {
                _context8.n = 7;
                break;
              }
              _context8.n = 7;
              return this.app.network.sendRequestAsTransaction('faucet-oauth-result', {
                success: true,
                already_issued: true,
                publickey: identity.publickey,
                message: 'This Saito public key is already registered for the Faucet.'
              }, null, _peer.publicKey);
            case 7:
              return _context8.a(2, {
                status: 200,
                popup: {
                  ok: true,
                  title: 'Already registered',
                  message: 'This Saito public key is already registered for the Faucet. You can close this window.'
                }
              });
            case 8:
              _context8.n = 9;
              return this.db.insertRecord(identity);
            case 9:
              if (_context8.v) {
                _context8.n = 11;
                break;
              }
              console.log('[Faucet] acceptAuthenticatedIdentity insert failed');
              _context8.n = 10;
              return this.db.insertActivity({
                requester_publickey: identity.publickey,
                provider: identity.provider,
                provider_user_id: identity.provider_user_id,
                provider_username: identity.provider_username,
                requested_amount: this.amount.toString(),
                request_status: 'rejected',
                request_reason: 'registration_failed',
                payment_status: 'none'
              });
            case 10:
              return _context8.a(2, {
                status: 500,
                popup: {
                  ok: false,
                  title: 'Registration failed',
                  message: 'Could not create a Faucet registration. Please try again.'
                }
              });
            case 11:
              _context8.n = 12;
              return this.app.network.getPeer(identity.publickey);
            case 12:
              peer = _context8.v;
              if ((_peer4 = peer) !== null && _peer4 !== void 0 && _peer4.publicKey) {
                _context8.n = 14;
                break;
              }
              _context8.n = 13;
              return this.app.network.getPeers();
            case 13:
              _peers = _context8.v;
              peer = _peers.find(function (p) {
                return (p === null || p === void 0 ? void 0 : p.publicKey) === identity.publickey && (p === null || p === void 0 ? void 0 : p.status) !== 'disconnected';
              });
            case 14:
              console.log('[Faucet] acceptAuthenticatedIdentity inserted — will issue after faucet request confirms');
              _context8.n = 15;
              return this.db.insertActivity({
                requester_publickey: identity.publickey,
                provider: identity.provider,
                provider_user_id: identity.provider_user_id,
                provider_username: identity.provider_username,
                requested_amount: this.amount.toString(),
                request_status: 'accepted',
                payment_status: 'none'
              });
            case 15:
              if ((_peer5 = peer) !== null && _peer5 !== void 0 && _peer5.publicKey) {
                _context8.n = 16;
                break;
              }
              console.log('[Faucet] acceptAuthenticatedIdentity no connected peer for ' + identity.publickey);
              return _context8.a(2, {
                status: 200,
                popup: {
                  ok: true,
                  title: 'Registration complete',
                  message: 'Registration succeeded, but your Saito browser was not connected. Return to Get SAITO and try again, or keep that window open while signing in.'
                }
              });
            case 16:
              console.log('[Faucet] acceptAuthenticatedIdentity notifying browser already_issued=false');
              _context8.n = 17;
              return this.app.network.sendRequestAsTransaction('faucet-oauth-result', {
                success: true,
                already_issued: false,
                publickey: identity.publickey,
                message: 'Faucet OAuth registration succeeded.'
              }, null, peer.publicKey);
            case 17:
              return _context8.a(2, {
                status: 200,
                popup: {
                  ok: true,
                  title: 'Account verified',
                  message: 'Your account was verified. You can close this window — Get SAITO will continue automatically.'
                }
              });
          }
        }, _callee8, this);
      }));
      function acceptAuthenticatedIdentity() {
        return _acceptAuthenticatedIdentity.apply(this, arguments);
      }
      return acceptAuthenticatedIdentity;
    }()
    /**
     * Free mode skips OAuth and allows the same public key to claim again after
     * a rolling 24-hour cooldown.
     */
  }, {
    key: "acceptFreeUseIdentity",
    value: function () {
      var _acceptFreeUseIdentity = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _peer6, _peer8;
        var identity,
          eligibility,
          peer,
          peers,
          _peer7,
          _args9 = arguments;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              identity = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
              _context9.n = 1;
              return this.db.prepareFreeUseClaim(identity, Date.now(), FREE_USE_COOLDOWN_MS);
            case 1:
              eligibility = _context9.v;
              _context9.n = 2;
              return this.app.network.getPeer(identity.publickey);
            case 2:
              peer = _context9.v;
              if ((_peer6 = peer) !== null && _peer6 !== void 0 && _peer6.publicKey) {
                _context9.n = 4;
                break;
              }
              _context9.n = 3;
              return this.app.network.getPeers();
            case 3:
              peers = _context9.v;
              peer = peers.find(function (p) {
                return (p === null || p === void 0 ? void 0 : p.publicKey) === identity.publickey && (p === null || p === void 0 ? void 0 : p.status) !== 'disconnected';
              });
            case 4:
              if (eligibility.eligible) {
                _context9.n = 6;
                break;
              }
              if (!((_peer7 = peer) !== null && _peer7 !== void 0 && _peer7.publicKey)) {
                _context9.n = 5;
                break;
              }
              _context9.n = 5;
              return this.app.network.sendRequestAsTransaction('faucet-oauth-result', {
                success: true,
                already_issued: true,
                daily_limit: true,
                retry_at: eligibility.retry_at,
                publickey: identity.publickey,
                message: 'This Saito public key has already used the faucet in the last 24 hours.'
              }, null, peer.publicKey);
            case 5:
              return _context9.a(2, {
                status: 200,
                popup: {
                  ok: true,
                  title: 'Daily faucet limit reached',
                  message: 'This Saito public key can use the faucet again after the 24-hour cooldown.'
                }
              });
            case 6:
              if ((_peer8 = peer) !== null && _peer8 !== void 0 && _peer8.publicKey) {
                _context9.n = 7;
                break;
              }
              return _context9.a(2, {
                status: 200,
                popup: {
                  ok: true,
                  title: 'Faucet request ready',
                  message: 'Return to Get SAITO while this browser is connected and try again.'
                }
              });
            case 7:
              _context9.n = 8;
              return this.app.network.sendRequestAsTransaction('faucet-oauth-result', {
                success: true,
                already_issued: false,
                daily_limit: true,
                publickey: identity.publickey,
                message: 'Daily faucet request accepted.'
              }, null, peer.publicKey);
            case 8:
              return _context9.a(2, {
                status: 200,
                popup: {
                  ok: true,
                  title: 'Faucet request accepted',
                  message: 'Your daily faucet request will continue automatically.'
                }
              });
          }
        }, _callee9, this);
      }));
      function acceptFreeUseIdentity() {
        return _acceptFreeUseIdentity.apply(this, arguments);
      }
      return acceptFreeUseIdentity;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              this.header = new SaitoHeader(this.app, this);
              _context0.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.header.header_class = 'arcade';
              this.addComponent(this.header);
              _context0.n = 3;
              return _superPropGet(Faucet, "render", this, 3)([]);
            case 3:
              this.main.render();
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "createFaucetClaimTransaction",
    value: function () {
      var _createFaucetClaimTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var newtx;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context1.v;
              newtx.msg = {
                module: 'Faucet',
                request: 'faucet request'
              };
              _context1.n = 2;
              return newtx.sign();
            case 2:
              return _context1.a(2, newtx);
          }
        }, _callee1, this);
      }));
      function createFaucetClaimTransaction() {
        return _createFaucetClaimTransaction.apply(this, arguments);
      }
      return createFaucetClaimTransaction;
    }()
  }, {
    key: "receiveFaucetClaimTransaction",
    value: function () {
      var _receiveFaucetClaimTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var tx,
          blk,
          receiver,
          request_block_id,
          request_block_hash,
          request_tx_signature,
          registration,
          began,
          open,
          activity_id,
          newtx,
          completed,
          _args10 = arguments,
          _t3,
          _t4;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              tx = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : null;
              blk = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : null;
              if (!(tx == null || blk == null)) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              receiver = tx.from[0].publicKey;
              console.log('[Faucet] receiveFaucetClaimTransaction receiver=' + receiver);
              request_block_id = blk.id != null ? String(blk.id) : '';
              request_block_hash = blk.hash || '';
              request_tx_signature = tx.signature || '';
              _context10.n = 2;
              return this.db.getRecord({
                publickey: receiver
              });
            case 2:
              registration = _context10.v;
              _context10.n = 3;
              return this.db.updateRecord({
                publickey: receiver,
                issuance_status: 'eligible'
              }, {
                issuance_status: 'pending'
              });
            case 3:
              began = _context10.v;
              if (began) {
                _context10.n = 5;
                break;
              }
              console.log('[Faucet] receiveFaucetClaimTransaction refused — no eligible registration for ' + receiver);
              _context10.n = 4;
              return this.db.insertActivity({
                requester_publickey: receiver,
                provider: (registration === null || registration === void 0 ? void 0 : registration.provider) || '',
                provider_user_id: (registration === null || registration === void 0 ? void 0 : registration.provider_user_id) || '',
                provider_username: (registration === null || registration === void 0 ? void 0 : registration.provider_username) || '',
                requested_amount: this.amount.toString(),
                request_status: 'rejected',
                request_reason: 'no_eligible_registration',
                request_tx_signature: request_tx_signature,
                request_block_id: request_block_id,
                request_block_hash: request_block_hash,
                request_longest_chain: 1,
                payment_status: 'none'
              });
            case 4:
              return _context10.a(2);
            case 5:
              console.log('[Faucet] receiveFaucetClaimTransaction queueing payment for ' + receiver);
              _context10.n = 6;
              return this.db.findOpenActivity(receiver);
            case 6:
              open = _context10.v;
              _t3 = open === null || open === void 0 ? void 0 : open.id;
              if (_t3) {
                _context10.n = 8;
                break;
              }
              _context10.n = 7;
              return this.db.insertActivity({
                requester_publickey: receiver,
                provider: (registration === null || registration === void 0 ? void 0 : registration.provider) || '',
                provider_user_id: (registration === null || registration === void 0 ? void 0 : registration.provider_user_id) || '',
                provider_username: (registration === null || registration === void 0 ? void 0 : registration.provider_username) || '',
                requested_amount: this.amount.toString(),
                request_status: 'accepted',
                request_tx_signature: request_tx_signature,
                request_block_id: request_block_id,
                request_block_hash: request_block_hash,
                request_longest_chain: 1,
                payment_status: 'queued'
              });
            case 7:
              _t3 = _context10.v;
            case 8:
              activity_id = _t3;
              if (!(open !== null && open !== void 0 && open.id)) {
                _context10.n = 9;
                break;
              }
              _context10.n = 9;
              return this.db.updateActivity(activity_id, {
                request_tx_signature: request_tx_signature,
                request_block_id: request_block_id,
                request_block_hash: request_block_hash,
                request_longest_chain: 1,
                payment_status: 'queued'
              });
            case 9:
              _context10.p = 9;
              _context10.n = 10;
              return this.wallet.queuePayment({
                publickey: receiver
              });
            case 10:
              newtx = _context10.v;
              if (!activity_id) {
                _context10.n = 11;
                break;
              }
              _context10.n = 11;
              return this.db.updateActivity(activity_id, {
                payment_status: 'broadcast',
                payment_tx_signature: newtx.signature || '',
                paid_at: Date.now()
              });
            case 11:
              _context10.n = 12;
              return this.db.updateRecord({
                publickey: receiver,
                issuance_status: 'pending'
              }, {
                issuance_status: 'issued',
                issuance_amount: this.amount.toString(),
                issuance_tx_signature: newtx.signature,
                issued_at: Date.now()
              });
            case 12:
              completed = _context10.v;
              console.log('[Faucet] receiveFaucetClaimTransaction payout queued/created signature=' + ((newtx === null || newtx === void 0 ? void 0 : newtx.signature) || ''));
              if (!completed) {
                console.error('[Faucet] issuance propagated but failed to mark registration issued for ' + receiver + ' sig=' + newtx.signature);
              }
              _context10.n = 15;
              break;
            case 13:
              _context10.p = 13;
              _t4 = _context10.v;
              console.error('[Faucet] payout failed after pending claim; reverting to eligible', _t4);
              if (!activity_id) {
                _context10.n = 14;
                break;
              }
              _context10.n = 14;
              return this.db.updateActivity(activity_id, {
                payment_status: 'failed'
              });
            case 14:
              _context10.n = 15;
              return this.db.updateRecord({
                publickey: receiver,
                issuance_status: 'pending'
              }, {
                issuance_status: 'eligible'
              });
            case 15:
              return _context10.a(2);
          }
        }, _callee10, this, [[9, 13]]);
      }));
      function receiveFaucetClaimTransaction() {
        return _receiveFaucetClaimTransaction.apply(this, arguments);
      }
      return receiveFaucetClaimTransaction;
    }()
  }, {
    key: "receiveFaucetIssuanceTransaction",
    value: function () {
      var _receiveFaucetIssuanceTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(tx) {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!(!this.app.BROWSER || !(tx !== null && tx !== void 0 && tx.isTo(this.publicKey)))) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              console.log('[Faucet] receiveFaucetIssuanceTransaction telling waiting UI issuance completed signature=' + (tx.signature || ''));
              this.waiting_overlay.close();
              this.success_overlay.render({
                tx: tx
              });
            case 2:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function receiveFaucetIssuanceTransaction(_x6) {
        return _receiveFaucetIssuanceTransaction.apply(this, arguments);
      }
      return receiveFaucetIssuanceTransaction;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(blk, tx) {
        var conf,
          txmsg,
          _tx$from,
          _args12 = arguments;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              conf = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : 0;
              if (!(conf != 0)) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              txmsg = tx.returnMessage();
              if (!(!this.app.BROWSER && (txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'faucet issuance')) {
                _context12.n = 2;
                break;
              }
              _context12.n = 2;
              return this.db.markPaymentIncluded(tx.signature, blk === null || blk === void 0 ? void 0 : blk.id, blk === null || blk === void 0 ? void 0 : blk.hash);
            case 2:
              if (!this.hasSeenTransaction(tx, blk)) {
                _context12.n = 3;
                break;
              }
              return _context12.a(2);
            case 3:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'faucet request')) {
                _context12.n = 5;
                break;
              }
              console.log('[Faucet] onConfirmation faucet request from=' + (((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || ''));
              if (this.app.BROWSER) {
                _context12.n = 4;
                break;
              }
              _context12.n = 4;
              return this.receiveFaucetClaimTransaction(tx, blk);
            case 4:
              return _context12.a(2);
            case 5:
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'faucet issuance')) {
                _context12.n = 6;
                break;
              }
              console.log('[Faucet] onConfirmation faucet issuance to=' + (tx.to || []).map(function (s) {
                return s.publicKey + ':' + String(s.amount || '');
              }).join(','));
              _context12.n = 6;
              return this.receiveFaucetIssuanceTransaction(tx);
            case 6:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function onConfirmation(_x7, _x8) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(blk, lc) {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return this.wallet.onNewBlock(blk, lc);
            case 1:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function onNewBlock(_x9, _x0) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(block_id, block_hash, lc) {
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              this.wallet.onChainReorganization(block_id, block_hash, lc);
              if (this.app.BROWSER) {
                _context14.n = 1;
                break;
              }
              _context14.n = 1;
              return this.db.markChainState(block_id, block_hash, lc);
            case 1:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function onChainReorganization(_x1, _x10, _x11) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }()
  }, {
    key: "adminSnapshot",
    value: function () {
      var _adminSnapshot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var _this4 = this,
          _this$app$options$fau,
          _this$app$options$fau2;
        var filter,
          balance_nolan,
          _iterator,
          _step,
          slip,
          toSaito,
          activity,
          _args15 = arguments,
          _t5,
          _t6,
          _t7,
          _t8,
          _t9,
          _t0,
          _t1,
          _t10,
          _t11,
          _t12;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              filter = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : 'recent';
              if (filter !== 'pending' && filter !== 'completed' && filter !== 'failed') {
                filter = 'recent';
              }
              _context15.n = 1;
              return this.wallet.getSnapshotBalance();
            case 1:
              balance_nolan = 0n;
              _iterator = _createForOfIteratorHelper(this.wallet.slips || []);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  slip = _step.value;
                  try {
                    balance_nolan += BigInt(slip.amount || 0);
                  } catch (err) {
                    // ignore malformed slip amounts
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              toSaito = function toSaito(nolan) {
                try {
                  return String(_this4.app.wallet.convertNolanToSaito(BigInt(nolan || 0)));
                } catch (err) {
                  return '0';
                }
              };
              _context15.n = 2;
              return this.db.listActivity(filter, 50);
            case 2:
              activity = _context15.v;
              _t5 = this.wallet.publickey || ((_this$app$options$fau = this.app.options.faucet) === null || _this$app$options$fau === void 0 ? void 0 : _this$app$options$fau.publickey) || '';
              _t6 = ((_this$app$options$fau2 = this.app.options.faucet) === null || _this$app$options$fau2 === void 0 ? void 0 : _this$app$options$fau2.privatekey) || '';
              _t7 = balance_nolan.toString();
              _t8 = toSaito(balance_nolan);
              _t9 = this.amount.toString();
              _t0 = toSaito(this.amount);
              _t1 = (this.wallet.queue || []).length;
              _context15.n = 3;
              return this.db.activityCounts();
            case 3:
              _t10 = _context15.v;
              _t11 = filter;
              _t12 = activity.map(function (row) {
                return {
                  id: row.id,
                  created_at: row.created_at,
                  requester_publickey: row.requester_publickey,
                  provider: row.provider,
                  provider_user_id: row.provider_user_id,
                  provider_username: row.provider_username,
                  requested_amount: row.requested_amount,
                  requested_saito: toSaito(row.requested_amount),
                  request_status: row.request_status,
                  request_reason: row.request_reason,
                  request_tx_signature: row.request_tx_signature,
                  request_block_id: row.request_block_id,
                  request_block_hash: row.request_block_hash,
                  request_longest_chain: Number(row.request_longest_chain) === 1,
                  payment_status: row.payment_status,
                  payment_tx_signature: row.payment_tx_signature,
                  paid_at: row.paid_at,
                  payment_block_id: row.payment_block_id,
                  payment_block_hash: row.payment_block_hash,
                  payment_longest_chain: Number(row.payment_longest_chain) === 1
                };
              });
              return _context15.a(2, {
                publickey: _t5,
                privatekey: _t6,
                balance_nolan: _t7,
                balance_saito: _t8,
                payout_nolan: _t9,
                payout_saito: _t0,
                queue_length: _t1,
                counts: _t10,
                filter: _t11,
                activity: _t12
              });
          }
        }, _callee15, this);
      }));
      function adminSnapshot() {
        return _adminSnapshot.apply(this, arguments);
      }
      return adminSnapshot;
    }()
  }, {
    key: "adminConfigSnapshot",
    value: function adminConfigSnapshot() {
      return {
        github_configured: !!this.oauth.secret_github,
        twitter_configured: !!this.oauth.secret_twitter,
        free_use: this.free_use === true
      };
    }
  }, {
    key: "updateAdminConfig",
    value: function updateAdminConfig() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var githubSecret = String(config.github_secret || '');
      var twitterSecret = String(config.twitter_secret || '');

      // Empty secret fields preserve the current value. Secrets are saved in
      // server options but never included in the returned snapshot.
      if (githubSecret) {
        this.oauth.secret_github = githubSecret;
      }
      if (twitterSecret) {
        this.oauth.secret_twitter = twitterSecret;
      }
      if (!this.app.options) {
        this.app.options = {};
      }
      if (!this.app.options.faucet || _typeof(this.app.options.faucet) !== 'object') {
        this.app.options.faucet = {};
      }
      this.app.options.faucet.github_secret = this.oauth.secret_github;
      this.app.options.faucet.twitter_secret = this.oauth.secret_twitter;
      this.free_use = config.free_use === true || config.free_use === '1' || config.free_use === 'on';
      this.mode = saveFaucetMode(this.app, {
        free: this.free_use,
        github: !!this.oauth.secret_github,
        twitter: !!this.oauth.secret_twitter
      });
      console.log('FAUCET CONFIG: OAuth updated — GitHub:', this.oauth.secret_github ? 'configured' : 'not set', '| X:', this.oauth.secret_twitter ? 'configured' : 'not set', '| Free Use:', this.free_use ? 'on' : 'off');
      return this.adminConfigSnapshot();
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(app) {
        var _txmsg, _txmsg2, _txmsg3;
        var tx,
          peer,
          mycallback,
          txmsg,
          available,
          amount,
          _tx$from3,
          _tx$from2,
          _publickey,
          publickey,
          data,
          _this$app$modules$ret,
          purchase,
          _this$app$modules$ret2,
          _purchase,
          claim_tx,
          _args16 = arguments,
          _t13,
          _t14;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              tx = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : null;
              peer = _args16.length > 2 ? _args16[2] : undefined;
              mycallback = _args16.length > 3 && _args16[3] !== undefined ? _args16[3] : null;
              if (!(tx == null)) {
                _context16.n = 1;
                break;
              }
              return _context16.a(2, 0);
            case 1:
              _context16.p = 1;
              txmsg = tx.returnMessage();
              _context16.n = 3;
              break;
            case 2:
              _context16.p = 2;
              _t13 = _context16.v;
              return _context16.a(2, 0);
            case 3:
              if (!(((_txmsg = txmsg) === null || _txmsg === void 0 ? void 0 : _txmsg.request) === 'faucet available')) {
                _context16.n = 5;
                break;
              }
              if (!this.app.BROWSER) {
                _context16.n = 4;
                break;
              }
              return _context16.a(2, 0);
            case 4:
              available = !!(this.free_use || this.oauth.secret_github || this.oauth.secret_twitter);
              amount = available ? Number(this.app.wallet.convertNolanToSaito(this.amount)) : 0;
              if (typeof mycallback === 'function') {
                mycallback({
                  available: available,
                  amount: amount,
                  free_use: this.free_use === true
                });
              }
              return _context16.a(2, 1);
            case 5:
              if (!(((_txmsg2 = txmsg) === null || _txmsg2 === void 0 ? void 0 : _txmsg2.request) === 'faucet free use')) {
                _context16.n = 11;
                break;
              }
              if (!this.app.BROWSER) {
                _context16.n = 6;
                break;
              }
              return _context16.a(2, 0);
            case 6:
              if (!(this.free_use !== true)) {
                _context16.n = 8;
                break;
              }
              console.log('[Faucet] faucet free use refused — free_use is off');
              _publickey = String(((_tx$from2 = tx.from) === null || _tx$from2 === void 0 || (_tx$from2 = _tx$from2[0]) === null || _tx$from2 === void 0 ? void 0 : _tx$from2.publicKey) || '').trim();
              if (!_publickey) {
                _context16.n = 7;
                break;
              }
              _context16.n = 7;
              return this.db.insertActivity({
                requester_publickey: _publickey,
                provider: 'free_use',
                requested_amount: this.amount.toString(),
                request_status: 'rejected',
                request_reason: 'free_use_disabled',
                payment_status: 'none'
              });
            case 7:
              return _context16.a(2, 1);
            case 8:
              publickey = String(((_tx$from3 = tx.from) === null || _tx$from3 === void 0 || (_tx$from3 = _tx$from3[0]) === null || _tx$from3 === void 0 ? void 0 : _tx$from3.publicKey) || '').trim();
              if (publickey) {
                _context16.n = 9;
                break;
              }
              console.log('[Faucet] faucet free use refused — no sender publickey');
              return _context16.a(2, 1);
            case 9:
              console.log('[Faucet] faucet free use publickey=' + publickey);
              _context16.n = 10;
              return this.acceptAuthenticatedIdentity({
                provider: 'free_use',
                provider_user_id: publickey,
                provider_username: '',
                provider_display_name: '',
                provider_account_created_at: 0,
                publickey: publickey
              });
            case 10:
              return _context16.a(2, 1);
            case 11:
              if (!(((_txmsg3 = txmsg) === null || _txmsg3 === void 0 ? void 0 : _txmsg3.request) === 'faucet-oauth-result')) {
                _context16.n = 18;
                break;
              }
              if (this.app.BROWSER) {
                _context16.n = 12;
                break;
              }
              return _context16.a(2, 0);
            case 12:
              data = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
              if (!data.already_issued) {
                _context16.n = 13;
                break;
              }
              try {
                purchase = (_this$app$modules$ret = this.app.modules.returnModule('BuySaito')) === null || _this$app$modules$ret === void 0 ? void 0 : _this$app$modules$ret.purchase_overlay;
                if (purchase && typeof purchase.showFaucetAlreadyIssuedNotice === 'function') {
                  if (!document.querySelector('#purchase-container') && purchase.active) {
                    purchase.render();
                  }
                  purchase.showFaucetAlreadyIssuedNotice(data);
                }
              } catch (err) {
                console.error('FAUCET: failed to show already-issued notice', err);
              }
              return _context16.a(2, 1);
            case 13:
              try {
                _purchase = (_this$app$modules$ret2 = this.app.modules.returnModule('BuySaito')) === null || _this$app$modules$ret2 === void 0 ? void 0 : _this$app$modules$ret2.purchase_overlay;
                if (_purchase) {
                  _purchase.acquisition_stage = 'default';
                  _purchase.stage1_html = null;
                  if (_purchase.overlay) {
                    _purchase.overlay.close();
                  }
                  _purchase.active = false;
                }
              } catch (err) {
                console.error('FAUCET: failed to dismiss Get SAITO UI', err);
              }
              this.waiting_overlay.render();
              if (!this.waiting_overlay.dev_mode) {
                _context16.n = 14;
                break;
              }
              return _context16.a(2, 1);
            case 14:
              _context16.p = 14;
              _context16.n = 15;
              return this.createFaucetClaimTransaction();
            case 15:
              claim_tx = _context16.v;
              console.log('[Faucet] faucet-oauth-result propagating faucet request signature=' + ((claim_tx === null || claim_tx === void 0 ? void 0 : claim_tx.signature) || ''));
              this.app.network.propagateTransaction(claim_tx);
              _context16.n = 17;
              break;
            case 16:
              _context16.p = 16;
              _t14 = _context16.v;
              console.error('[Faucet] failed to create/propagate request', _t14);
              this.waiting_overlay.render({
                timeout: true
              });
            case 17:
              return _context16.a(2, 1);
            case 18:
              return _context16.a(2, _superPropGet(Faucet, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee16, this, [[14, 16], [1, 2]]);
      }));
      function handlePeerTransaction(_x12) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var faucet_self = this;
      var slug = encodeURI(this.returnSlug());
      this.oauth.attachRoutes(expressapp);
      expressapp.get('/' + slug, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(req, res) {
          var updatedSocial, html;
          return _regenerator().w(function (_context17) {
            while (1) switch (_context17.n) {
              case 0:
                updatedSocial = Object.assign({}, faucet_self.social);
                html = FaucetHome(app, faucet_self, app.build_number, updatedSocial);
                if (res.finished) {
                  _context17.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context17.a(2, res.send(html));
              case 1:
                return _context17.a(2);
            }
          }, _callee17);
        }));
        return function (_x13, _x14) {
          return _ref.apply(this, arguments);
        };
      }());
      expressapp.use('/' + slug, express["static"](webdir));
    }
  }]);
}(ModTemplate);
module.exports = Faucet;